import moment from 'moment';
import { COMPOSICOES_DA_FROTA, HORARIOS_DE_CARREGAMENTO, PONTOS_DA_ROTA, RASTREAMENTO, TRANSPORTADORA_DA_SESSAO } from './dados';
import { comoLista, contarComVolumePor, falhar, ofertas, paginar, viagens } from './estado';

const STATUS_DISPONIVEL_PARA_ACEITE = 'em_andamento';
const VOLUME_POR_VIAGEM = 30;

const comDisponibilidade = (oferta) => ({
    ...oferta,
    saldo_disponivel: Math.max(0, Number(oferta.volume_total || 0) - Number(oferta.volumes?.agendado || 0)),
    rastreamento: RASTREAMENTO,
});

const ofertasDisponiveis = () => ofertas.filter((oferta) => oferta.status === STATUS_DISPONIVEL_PARA_ACEITE).map(comDisponibilidade);

const fretesDaSessao = () => viagens.filter((viagem) => Number(viagem.transportadora?.id) === Number(TRANSPORTADORA_DA_SESSAO.id));

const buscarOfertaDisponivel = (id) => ofertasDisponiveis().find((oferta) => Number(oferta.id) === Number(id));

const resumoDaOferta = (oferta) => ({
    id: oferta.id,
    numero: oferta.numero,
    embarcadora: oferta.embarcadora,
    produto_nome: oferta.produto_acondicionamento?.produto_nome,
    tipo_documento: oferta.tipo_documento,
    numero_documento: oferta.numero_documento,
    armazem_origem: oferta.armazem_origem,
    armazem_destino: oferta.armazem_destino,
});

const valorDoEixo = (oferta, quantidadeDeEixos) => Number(
    (oferta.valores_por_eixo || []).find((item) => Number(item.quantidade_eixos) === Number(quantidadeDeEixos))?.valor_por_tonelada
    ?? oferta.valores_por_eixo?.[0]?.valor_por_tonelada
    ?? 0
);

const aceitar = (oferta, corpo) => {
    const composicao = COMPOSICOES_DA_FROTA.find((item) => Number(item.id) === Number(corpo.composicao_id));
    if (!composicao) return falhar(422, 'Composição não encontrada na sua frota.');
    if (!corpo.data || !corpo.hora) return falhar(422, 'Informe o dia e o horário do carregamento.');

    const id = Math.max(...viagens.map((viagem) => viagem.id)) + 1;
    const viagem = {
        id,
        numero: `V-${id}`,
        oferta_id: oferta.id,
        status: 'agendado',
        inicio_em: moment(`${corpo.data}T${corpo.hora}`).format('YYYY-MM-DDTHH:mm:ss'),
        volume: Math.min(VOLUME_POR_VIAGEM, composicao.capacidade_toneladas),
        motorista: composicao.motorista,
        cavalo: composicao.cavalo,
        carroceria: composicao.carroceria,
        transportadora: TRANSPORTADORA_DA_SESSAO,
        oferta: resumoDaOferta(oferta),
        situacao: 'em_local_operacional',
        valor_por_tonelada: valorDoEixo(oferta, composicao.cavalo.total_eixos),
        agendamento: { data: corpo.data, hora: corpo.hora },
        ordem_carregamento: { numero: `OC-${id}`, url: 'https://example.com/ordem-de-carregamento.pdf' },
        rota: { distancia_km: 2140, pontos: PONTOS_DA_ROTA },
        posicao: null,
        anexos: [],
        timeline: [{ horario: moment().format('YYYY-MM-DDTHH:mm:ss'), evento: 'Oferta aceita', local: oferta.armazem_origem.emp_nome_fantasia, usuario: TRANSPORTADORA_DA_SESSAO.emp_nome_fantasia, ambiente: 'Painel' }],
        planejado_real: [],
    };
    viagens.unshift(viagem);
    return { status: 201, data: { data: viagem } };
};

export const resolverDoTransportador = (metodo, caminho, parametros, corpo) => {
    if (metodo === 'get' && caminho === '') {
        const { data, pagination } = paginar(ofertasDisponiveis(), parametros);
        return { status: 200, data: { data, meta: { pagination } } };
    }

    if (metodo === 'get' && caminho === '/meus-fretes') {
        const status = comoLista(parametros.status);
        const todos = fretesDaSessao();
        const { data, pagination } = paginar(todos.filter((frete) => status.length === 0 || status.includes(frete.status)), parametros);
        return { status: 200, data: { data, meta: { pagination, counts: contarComVolumePor(todos, 'status') } } };
    }

    if (metodo === 'get' && /^\/meus-fretes\/\d+$/.test(caminho)) {
        const frete = fretesDaSessao().find((viagem) => Number(viagem.id) === Number(caminho.split('/')[2]));
        return frete ? { status: 200, data: { data: frete } } : falhar(404, 'Frete não encontrado.');
    }

    const [, ofertaId, recurso] = caminho.split('/');
    const oferta = /^\d+$/.test(ofertaId || '') ? buscarOfertaDisponivel(ofertaId) : null;
    if (!oferta) return falhar(404, 'Oferta não encontrada.');

    if (metodo === 'get' && !recurso) return { status: 200, data: { data: oferta } };
    if (metodo === 'get' && recurso === 'composicoes') return { status: 200, data: { data: COMPOSICOES_DA_FROTA } };
    if (metodo === 'get' && recurso === 'horarios') return { status: 200, data: { data: HORARIOS_DE_CARREGAMENTO } };
    if (metodo === 'post' && recurso === 'aceite') return aceitar(oferta, corpo);

    return falhar(404, 'Rota do painel de ofertas do transportador ainda não simulada.');
};
